<template>
  
    <div class="row ch design">
      <slot name="leftIcon"></slot>
      <slot name="left"></slot>
      <slot name="center"></slot>
      <slot name="right"></slot>
      <slot name="rightIcon"></slot>
    </div>

    <!-- 
    
    <InputBack class="w500">
      <template #leftIcon>icon</template>
      <template #left>left</template>
      <template #center><input type="text" style="width: 100%;" class="inline" @input="check()" placeholder="login" v-model="login"></template>
      <template #rightIcon>icon</template>
    </InputBack>
    
    <p class="mini w250">https://toodemo.com/{{ login }}</p>        
    <br>
    <p class="button form" @click="update()">Next</p> 
    
    -->
      
</template>

<script>
import { defineComponent } from 'vue';
export default defineComponent({data() {return {}}});

</script>
<style scoped>
  .design{
    background: #252525;
    border: 1px solid #282828;
    border-radius: 10px;
    height: 44px;
    padding: 0px 12px;
    margin: 12px 0;
  }
</style>